import { render, staticRenderFns } from "./RegimenesAduaneros.vue?vue&type=template&id=3ccaea4a&scoped=true&"
import script from "./RegimenesAduaneros.vue?vue&type=script&lang=js&"
export * from "./RegimenesAduaneros.vue?vue&type=script&lang=js&"
import style0 from "./RegimenesAduaneros.vue?vue&type=style&index=0&id=3ccaea4a&lang=scss&scoped=true&"
import style1 from "./RegimenesAduaneros.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccaea4a",
  null
  
)

export default component.exports